import React from "react";
import { Route } from "react-router-dom";

import { policiesRoutes } from "./routes";

export const PoliciesRoutes = () => {
  return (
    <>
      {policiesRoutes.map(({ path, Component, exact = false }) => (
        <Route path={path} key={path} exact={exact}>
          <Component />
        </Route>
      ))}
    </>
  );
};
